import { CANVAS_LEFT_MARGIN, CANVAS_WIDTH } from '@constants/canvas/general';

/**
 * Guards the divisions below. React Flow clamps zoom to `[MIN_ZOOM, MAX_ZOOM]`
 * and the slice defaults to `1`, so zero should not arrive — but a zero would
 * yield an `Infinity` extent, which pans the canvas into nothing rather than
 * failing visibly.
 */
const safeZoom = (zoom: number) => (zoom > 0 ? zoom : 1);

export const getExtentRightBound = (containerWidth: number, zoom: number) =>
  Math.max(CANVAS_WIDTH, containerWidth / safeZoom(zoom) - CANVAS_LEFT_MARGIN);

export const getExtentBottomBound = (
  canvasHeight: number,
  containerHeight: number,
  zoom: number,
) =>
  canvasHeight * zoom < containerHeight
    ? containerHeight / safeZoom(zoom)
    : canvasHeight;
